import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import { TmFavourite, TmFavouriteList } from '../model/favourite';
import { ApiBase } from './apibase.service';


export class FavouriteBase extends ApiBase {
    protected favouriteBaseUrl = this.baseUrl + '/accounts';
    protected favouriteUrlWithEdp = this.favouriteBaseUrl + '/' + this.customerEdp;

    constructor(protected http: Http) {
        super(http);
    }
}(FavouriteBase as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Favourites extends FavouriteBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description get favourites for a specific customer edp
     *   @return {TmFavouriteList}
     */
    get(page: number, pageSize: number, itemNoOnly: boolean = false): Observable<TmFavouriteList> {
        return this.http
            .get(this.favouriteUrlWithEdp + '/favourites?page=' + page + '&pageSize=' + pageSize + '&itemNoOnly=' + itemNoOnly, {
                headers: this.userTokenJsonTypeHeader,
            })
            .map(favouriteData => favouriteData.json() as TmFavouriteList)
            .catch(this.handleError);
    }

    /** @description Adds new favourite to a specific customer edp
     *   @return {TmFavourite}
     */
    post(favourite: TmFavourite): Observable<TmFavourite> {
        return this.http
            .post(this.favouriteUrlWithEdp + '/favourites', favourite, { headers: this.userTokenJsonTypeHeader })
            .map(favouriteData => favouriteData.json() as TmFavourite)
            .catch(this.handleError);
    }

    /** @description Removes favourite from a specific customer edp
     *   @return {TmFavourite}
     */
    delete(itemNo: number) {
        return (
            this.http
                .delete(this.favouriteUrlWithEdp + '/favourites/' + itemNo, { headers: this.userTokenJsonTypeHeader })
                //.catch(Resp => { return (Observable.throw(Resp.json())); });
                .catch(this.handleError)
        );
    }

    /** @description Removes favourite from a specific customer edp
     *   @return {TmFavourite}
     */
    deleteAll(): Observable<any> {
        return this.http
            .delete(this.favouriteUrlWithEdp + '/favourites', { headers: this.userTokenJsonTypeHeader })
            .catch(this.handleError);
    }
}(Favourites as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/favourite.service.ts